<div class="row container">
  <div class="col-12 mb-4 px-0">
    <div class="text-center">
      <h3 class="fw-600">Verify Your Email</h3>
      <p class="mb-0 text-sm text__gray">
        We suggest using the email address you use at work.
      </p>
    </div>
    <app-text-input
      type="text"
      inputId="organisation-verify-email"
      label="Email Address"
      [isShowLabel]="false"
      placeholder="Enter Email Address"
      [isRequired]="false"
      [control]="utilityService.$formControl(verifyEmailForm.get('email')!)"
    ></app-text-input>
  </div>
  <button
    class="btn btn-secondary col-12"
    (click)="sendOtp()"
    [disabled]="verifyEmailForm.get('email')?.invalid"
  >
    Send OTP
  </button>
</div>
